// dependencies
import isPlainObject from "lodash/isPlainObject";

import getNested from "../../utils/GetNested";

// constants
import FieldLabels from "../../constants/FieldLabels";
// utils
import findPaths from "./findPaths";

const ErrorParser = (errorObject, version = 0) => {
	/*
        Parses an error response.

        Errors are objects where the keys are the field names and
        the values are an array of errors for that field.

        {
            fieldName1 : [error]
            fieldName2 : [error]
        }

        These can be deeply nested, so the `findPaths` function will find all
        deeply nested errors and return their key paths.
    */

	/**
	 * version 3 has a key, code, and message. A key can reference an input, a
	 * code is a unique, random set of 5 characters, and message is a user
	 * friendly message.
	 */
	if (version === 3) {
		const parsableErrorList = errorObject.map((error) => ({
			version: 3,
			fieldLabel: "",
			originalError: error.toJS(),
			field: error.get("key"),
			code: error.get("code"),
			message: error.get("message"),
			errorMessage: error.get("message"),
		}));

		return parsableErrorList.toJS();
	}

	if (!isPlainObject(errorObject)) {
		return [{ field: "", fieldLabel: "", message: "", errorMessage: "" }];
	}

	const errorDisplayList = [];
	const paths = findPaths(errorObject);

	paths.forEach((keyPath) => {
		const error = getNested(errorObject, keyPath, null);

		if (error === null) {
			return;
		}

		const joinPath = keyPath.join(".");
		const label = FieldLabels.getIn([joinPath, "label"], joinPath);
		const errorMessage = label ? `${label}: ${error}` : `${error}`;

		errorDisplayList.push({
			field: joinPath,
			fieldLabel: label,
			message: error,
			errorMessage,
		});
	});

	return errorDisplayList;
};

export default ErrorParser;
